<template>
  <div class="p-4 border">
    <div class="center-between">
      <div class="flex gap-2 items-center">
        <h3 v-text="t('subProductGroup.subProductGroupProduct.label')" />
        <font-awesome-icon :class="{disabled: isLast}" icon="arrow-down" class="icon" @click="$emit('moveDown')" />
        <font-awesome-icon :class="{disabled: isFirst}" icon="arrow-up" class="icon" @click="$emit('moveUp')" />
      </div>
      <close-icon class="block w-4 cursor-pointer transition-colors hover:text-primary" @click="$emit('remove', modelValue['@id'])" />
    </div>

    <fancy-input
      v-model="model.minAmount"
      :label="t('subProductGroup.subProductGroupProduct.minAmount')"
      :min="0"
      type="number"
      required
      class="mt-4"
    />
    <fancy-input
      v-model="model.maxAmount"
      :label="t('subProductGroup.subProductGroupProduct.maxAmount')"
      :min="0"
      type="number"
      class="mt-4"
    />
    <fancy-input
      v-model="model.unit"
      :label="t('subProductGroup.subProductGroupProduct.unit')"
      required
      class="mt-4"
    />
    <multiselect
      v-model="model.product"
      :loading="loadingProductOptions"
      :filter-results="false"
      :options="async (q) => loadProductOptions(q, model.product)"
      :form-label="t('product.label')"
      searchable
      label="name"
    >
      <template #option="{ option }">
        <span v-if="option">
          {{ option.name }}
          ({{ option.productNumber }})
        </span>
      </template>
      <template #singlelabel="{ option }">
        <span v-if="option">
          {{ option.name }}
          ({{ option.productNumber }})
        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useModel } from '@/hooks/model';
import useLoadOptions from '@/hooks/api/loadOptions';
import FancyInput from '@/components/utils/forms/FancyInput.vue';
import Multiselect from '@/components/utils/forms/Multiselect.vue';
import CloseIcon from '@/assets/images/close.svg';
import SortIcon from '@/assets/images/sort.svg';

export default {
  name: 'SubProductGroupProductForm',
  components: {
    FancyInput,
    Multiselect,
    CloseIcon,
    SortIcon,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'update:modelValue', 'moveDown', 'moveUp'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const model = useModel(props, emit);

    const {
      loading: loadingProductOptions,
      loadOptions: loadProductOptions,
    } = useLoadOptions('/products', ['productNumber', 'name']);

    return {
      t,
      model,
      loadingProductOptions,
      loadProductOptions,
    };
  },
};
</script>
<style scoped lang="scss">
.icon {
  cursor: pointer;
  &.disabled {
    cursor: default;
    color: #CCC;
    pointer-events: none;
  }
}
</style>
